export const NL = {
    HOW_IT_WORK_PATH: '/waarom-medoen',
    MERCHANTPAGE_PATH: '/cashback/sheet/',
    CASHBACK_PATH: '/cashback',
    REDUCTION_PATH: '/kortingscodes',
    ACCOUNT_PATH: '/account',
    ACCOUNT_JACKPOT_PATH: '/account/cashback-overzicht',
    ACCOUNT_MESSAGE_PATH: '/account/mijn-berichten',
    ACCOUNT_CENTER_PATH: '/account/mijn-interesses',
    ACCOUNT_PROFILE_PATH: '/account/mijn-gegevens',
    ACCOUNT_GODCHILDREN_PATH: '/account/mijn-petekinderen',

    FAQ_PATH: '/faq',
    LEGAL_NOTICE_PATH: '/wettelijke-kennisgevingen',
    TERMS_PATH: '/terms-condition',
    TERMS_OF_SALES: '/terms-of-sales',
    CONTACTREQUEST_PATH: '/contact',
    UNSUBSCRIBE_PATH: '/unsubscribe',
    PASSWORD_RESET_PATH: '/wachtwoord-vergeten',
    INTERSTITIEL_CASHBACK_PATH: '/interstitiel/cashback/',
    INTERSTITIEL_TOOLBAR_CASHBACK_PATH: '/toolbar/interstitiel/cashback/',
    INTERSTITIEL_REDUCTION_PATH: '/interstitiel/kortingscodes/',
    INTERSTITIEL_TOOLBAR_REDUCTION_PATH: '/toolbar/interstitiel/kortingscodes/',
    TOOLBAR_PATH: '/toolbar',
    TOOLBAR_POST_INSTALL_PATH: '/toolbar/post-install',
    SPONSORSHIP_PATH: '/sponsoring',

    CASHBACK_MOST_POPULAR_PATH: '/cashback/de-meest-populaire',
    CASHBACK_ALPHA_PATH: '/cashback/alfabetisch/',
    CASHBACK_CATEGORY_PATH: '/cashback/categorie/',
    REDUCTION_MOST_POPULAR_PATH: '/kortingscodes/de-meest-populaire',
    REDUCTION_ALPHA_PATH: '/kortingscodes/alfabetisch/',
    REDUCTION_CATEGORY_PATH: '/kortingscodes/categorie/',
    ALPHA_PATH: 'alfabetisch',
    CATEGORY_PATH: 'categorie',
    MOST_POPULAR_PATH: 'de-meest-populaire',

    PAGE_NOT_FOUND_PATH: '/404'
};

export const PATH = NL;



// WEBPACK FOOTER //
// ./src/constants/path.js